import store from "../store"

/**
 * True when the user is actively interacting with a WorkQ table edit control.
 * Uses Redux edit-session count plus DOM markers for open selects / date editors.
 */
export function isWorkQEditInteractionActive() {
    if (store.getState().workqueue.editSessionCount > 0) {
        return true
    }

    if (typeof document === "undefined") {
        return false
    }

    if (document.querySelector('[data-workq-select-open="true"]')) {
        return true
    }

    if (document.querySelector('[data-workq-date-editor="true"]')) {
        return true
    }

    const active = document.activeElement
    if (active?.closest?.('[data-workq-select-shell]')) {
        return true
    }

    return false
}
